import type { ReactNode } from 'react'

const RING_STEP = 14

/** Decorative concentric rings, drawn in the current text colour so the role decides the hue. */
function Rings() {
  const radii = Array.from({ length: 22 }, (_, i) => 40 + i * RING_STEP)
  return (
    <svg
      aria-hidden="true"
      className="pointer-events-none absolute inset-y-0 right-0 h-full w-[60%] text-highlight opacity-30 max-sm:w-full"
      viewBox="0 0 900 300"
      preserveAspectRatio="xMaxYMid slice"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
    >
      {radii.map((r) => (
        <circle key={`a-${r}`} cx="640" cy="40" r={r} />
      ))}
      {radii.map((r) => (
        <circle key={`b-${r}`} cx="960" cy="250" r={r} />
      ))}
    </svg>
  )
}

export interface PageHeroProps {
  title: string
  children?: ReactNode
}

/** Full-bleed page header: navy-to-teal band, white title, decorative rings. */
export function PageHero({ title, children }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-hero to-hero-accent text-hero-on">
      <Rings />
      <div className="relative mx-auto max-w-[1180px] px-8 py-14 max-sm:px-4 max-sm:py-10">
        <h1 className="font-jakarta text-[44px] leading-tight font-bold max-sm:text-[30px]">
          {title}
        </h1>
        {children}
      </div>
    </section>
  )
}
